import React, { Component } from 'react';
import _ from 'lodash';
import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from "reactstrap";
import qs from "qs";
import { withRouter } from "react-router-dom";

import CollapseButton from '../dumb/collapseButton';
import baseFilter from "./baseFilter";


class MSIStatusFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.state = {
            filters: {},
            isOpen: false,
            activeCount: 0
        };

        this.aggregates = {
            'model_msi_status.msi_status': 'count'
        };

        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.updateAPIURL = this.updateAPIURL.bind(this);
        this.processResponse = this.processResponse.bind(this);
    }


    // ---------------------------------------------------------
    // URL helpers
    // ---------------------------------------------------------

    getActiveStatuses(search) {
        const query = qs.parse(search || '', {
            ignoreQueryPrefix: true
        });

        if (!query.msi_status) {
            return [];
        }

        return _.filter(
            _.split(query.msi_status, '_'),
            value => value !== ''
        );
    }


    // ---------------------------------------------------------
    // API request
    // ---------------------------------------------------------

    updateAPIURL(api_qs, newlistprops) {

        const activeStatuses = this.getActiveStatuses(
            newlistprops.location.search
        );

        if (activeStatuses.length > 0) {

            const filter_qs = {
                name: "model_msi_status",
                op: "any",
                val: {
                    name: "msi_status",
                    op: "in",
                    val: activeStatuses
                }
            };

            api_qs.filter = [
                ...(api_qs.filter || []),
                filter_qs
            ];
        }

        /*
         * Keep this aggregation because we need the counts
         * for the MSI checkboxes.
         */
        api_qs.agg = {
            ...api_qs.agg,
            ...this.aggregates
        };

        return api_qs;
    }


    // ---------------------------------------------------------
    // API response
    // ---------------------------------------------------------

    processResponse(response) {

        const agg = _.get(
            response,
            'meta.agg["model_msi_status.msi_status"].count'
        );

        if (!agg) {
            return;
        }

        const activeStatuses = this.getActiveStatuses(
            this.props.location.search
        );

        const filters = {};

        Object.keys(agg).forEach(msiStatus => {

            // Don't display the "None" option
            if (msiStatus === 'None') {
                return;
            }

            filters[msiStatus] = {
                count: agg[msiStatus],
                active: activeStatuses.indexOf(msiStatus) !== -1
            };
        });


        this.setState({
            filters,
            activeCount: activeStatuses.length
        });
    }


    // ---------------------------------------------------------
    // Checkbox
    // ---------------------------------------------------------

    toggleCheckbox(event) {

        const status = event.target.name;

        const current_qs = qs.parse(
            window.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        let statuses = this.getActiveStatuses(
            window.location.search
        );

        if (event.target.checked) {

            if (statuses.indexOf(status) === -1) {
                statuses = [...statuses, status];
            }

        } else {

            statuses = statuses.filter(
                value => value !== status
            );
        }


        if (statuses.length > 0) {
            current_qs.msi_status = statuses.sort().join('_');
        } else {
            delete current_qs.msi_status;
        }

        delete current_qs.page;


        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }


    // ---------------------------------------------------------
    // UI
    // ---------------------------------------------------------

    toggleCollapse() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }


    renderMSIStatusCheckboxes() {

        const active = [];
        const inactive = [];

        Object.entries(this.state.filters).forEach(
            ([msiStatus, details]) => {

                const checkbox = (
                    <FormGroup
                        check
                        key={msiStatus}
                    >
                        <Input
                            type="checkbox"
                            name={msiStatus}
                            onChange={this.toggleCheckbox}
                            checked={details.active}
                        />

                        {' '}

                        <Label
                            className="ml-4 mt-1"
                            check
                        >
                            {msiStatus}

                            {' '}

                            <span className="secondary">
                                ({details.count || 0})
                            </span>
                        </Label>
                    </FormGroup>
                );


                if (details.active) {
                    active.push(checkbox);
                } else {
                    inactive.push(checkbox);
                }
            }
        );


        return [
            ...active,
            ...inactive
        ];
    }


    // ---------------------------------------------------------
    // Lifecycle
    // ---------------------------------------------------------

    componentDidMount() {

        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }


    componentWillUnmount() {

        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }


    render() {

        return (
            <Card className="msi-filters mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >

                    <div className="d-inline w-50">
                        MSI Status
                    </div>

                    <div className="d-inline-block">
                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount} active
                            </strong>
                        )}
                    </div>

                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />

                </CardHeader>


                <Collapse isOpen={this.state.isOpen}>

                    <CardBody>
                        {this.renderMSIStatusCheckboxes()}
                    </CardBody>

                </Collapse>

            </Card>
        );
    }
}


export default withRouter(MSIStatusFilter);